import { useMutation } from "@tanstack/react-query";
import { forgetPassword } from "../api/forgetPassword";

export const useForgetPassword = () => {
  return useMutation({
    mutationFn: ({ email }) => forgetPassword({ email }),
  });
};

